<template>
  <div v-if="message" ref="summary" class="summary" role="alert" tabindex="-1">
    <strong>Check your details</strong>
    <p>{{ message }}</p>
    <ul v-if="items.length">
      <li v-for="item in items" :key="item">{{ item }}</li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import { nextTick, ref, watch } from "vue";
const props = defineProps<{ message: string; items: string[] }>();
const summary = ref<HTMLElement | null>(null);
watch(
  () => props.message,
  async (v) => {
    if (v) {
      await nextTick();
      summary.value?.focus();
    }
  }
);
</script>
<style scoped>
.summary {
  padding: 1rem;
  margin-bottom: 1rem;
  border-left: 4px solid #b42318;
  background: #fff1f0;
}
.summary p {
  margin: 0.35rem 0;
}
.summary ul {
  margin: 0.5rem 0 0;
  padding-left: 1.25rem;
}
</style>
